import React from "react";

import LeftContainer from "../components/LeftContainer";
import RightContainer from "../components/RightContainer";

const LayOut = () => {
  return (
    <div className="frameContainer body">
      <LeftContainer />
      <RightContainer />
    </div>
  );
};

export default LayOut;
